import React from 'react';

interface BadgeProps {
  label: string;
  variant?: 'success' | "processing" | 'warning' | 'error' | 'info' | 'neutral' | 'purple';
  size?: 'sm' | 'md';
}

const Badge: React.FC<BadgeProps> = ({ label, variant = 'neutral', size = 'md' }) => {
  let bgColor, textColor;
  
  switch (variant) {
    case 'success':
      bgColor = 'bg-green-100';
      textColor = 'text-green-800';
      break;
    case 'processing':
      bgColor = 'bg-blue-100';
      textColor = 'text-blue-800';
      break;
    case 'warning':
      bgColor = 'bg-yellow-100';
      textColor = 'text-yellow-800';
      break;
    case 'error':
      bgColor = 'bg-red-100';
      textColor = 'text-red-800';
      break;
    case 'info':
      bgColor = 'bg-blue-100';
      textColor = 'text-blue-800';
      break;
    case 'purple':
      bgColor = 'bg-purple-100';
      textColor = 'text-purple-800';
      break;
    case 'neutral':
    default:
      bgColor = 'bg-gray-100';
      textColor = 'text-gray-800';
      break;
  }

  const sizeClasses = size === 'sm' 
    ? 'px-2 py-1 text-xs' 
    : 'px-2.5 py-0.5 text-xs';

  return (
    <span className={`inline-flex items-center rounded-full font-medium ${bgColor} ${textColor} ${sizeClasses}`}>
      {label}
    </span>
  );
};

export default Badge;

